const LISTAR_DADOS = (state, payload) => {
    state.items = payload
  }

const LISTAR_SUBMODULOS = (state, payload) => {
  state.submodulos = payload
}

const CARREGANDO = (state, payload) => {
  state.carregando = payload
}

const LISTAR_ROTAS = (state, payload) => {
  state.rotas = payload
}

const INSERIR_VUE_COMPONENTE_MENU_SELECIONADO = (state,  payload) => {
  state.selecionado = payload
}

export {
    LISTAR_DADOS,
    LISTAR_SUBMODULOS,
    CARREGANDO,
    LISTAR_ROTAS,
    INSERIR_VUE_COMPONENTE_MENU_SELECIONADO
}